module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/instagram-icon-0edc91c13bebefaa391fe4ff83798df1.png";